import text from '@disy/cadenza-icons/add-text.svg';
import chartCombination from '@disy/cadenza-icons/chart-combination.svg';
import chart from '@disy/cadenza-icons/chart.svg';
import help from '@disy/cadenza-icons/help.svg';
import image from '@disy/cadenza-icons/image-file.svg';
import indicator from '@disy/cadenza-icons/indicator.svg';
import jasperReport from '@disy/cadenza-icons/jasper-report-lg.svg';
import map from '@disy/cadenza-icons/map.svg';
import stepControlIcon from '@disy/cadenza-icons/step-control.svg';
import table from '@disy/cadenza-icons/table.svg';
import view from '@disy/cadenza-icons/view.svg';
import webpage from '@disy/cadenza-icons/visualization-type-webpage-view.svg';
import extension from '@disy/cadenza-icons/visualization-type.svg';
import type { IconOptions } from '@disy/lib/icon';
import { icon } from '@disy/lib/icon';

import i18n from './view-type.properties';

/**
 * Enum of view types.
 *
 * @see net/disy/cadenza/workbook/model/ViewType.java
 */
export const ViewType = {
  TABLE: 'TABLE',
  MAP: 'MAP',
  CHART: 'CHART',
  TEXT: 'TEXT',
  OTHER: 'OTHER',
  IMAGE: 'IMAGE',
  REPORT: 'REPORT',
  EXTENSION: 'EXTENSION',
  CONTROLLER: 'CONTROLLER',
  WEBPAGE: 'WEBPAGE',
} as const;

export type ViewType = keyof typeof ViewType;

export type FrontendViewType = ViewType | 'CHART_COMBINATION';

const TYPE_ICONS: { [key in FrontendViewType]?: string } = {
  MAP: map,
  TABLE: table,
  CHART: chart,
  CHART_COMBINATION: chartCombination,
  TEXT: text,
  OTHER: indicator,
  IMAGE: image,
  REPORT: jasperReport,
  EXTENSION: extension,
  CONTROLLER: stepControlIcon,
  WEBPAGE: webpage,
};

// use the generic view icon to deal with cases where we lack the information to show a more precise one
const GENERIC_VIEW_ICON = view;
const UNKNOWN_TYPE_ICON = help;

export function viewTypeIcon(type?: FrontendViewType, options?: Exclude<IconOptions, 'styleClass'>) {
  const viewIcon = type ? TYPE_ICONS[type] || UNKNOWN_TYPE_ICON : GENERIC_VIEW_ICON;
  return icon(viewIcon, { label: type && viewTypeI18n(type), ...options, styleClass: 'view-type-icon' });
}

export function viewTypeI18n(type: FrontendViewType) {
  return i18n(`<${type}>`);
}
